import axios from "axios";

export default {
  namespaced: true,
  state: {
    searchInput: null,
    date: [new Date(),new Date()],
    status: null,
    actualPage: 1,
    offset: 0,
    pageQuantity: 10,
    selectedStatus: null,
    selectedCompany: 'OLX',
    selectedUser: null,
    selectedTypeFilter: null,
    statusOptions: [
      { text: 'Todos', value: null },
      { text: 'Activa', value: 'active' },
      { text: 'Inactiva', value: 'inactive' }
    ],
    companyOptions: [
      { text: 'OLX', value: 'OLX' },
      { text: 'Clicar', value: 'clicar' },
      { text: 'Wigo', value: 'wigo' }
    ],
    userOptions: [
      { text: 'Todos', value: null }
    ],
    typeFilterOptions: [
      { text: 'Asignados (Interno)', value: 'assigned' },
      { text: 'Asignados (CRM)', value: 'crm_assigned' },
      { text: 'No Asignados', value: 'unassigned' },
      { text: 'Inubicables', value: 'unreachable' },
    ]
  },
  getters: {},
  mutations: {
    resetFilters(state){
      state.actualPage = 1
      state.offset = 0
      state.pageQuantity = 10
    },
    setSelectedTypeFilter(state, payload) { 
      state.selectedUser = null
      state.selectedTypeFilter = payload 
    },
    setInput(state, value) {
      state.searchInput = value
    },
    setPageQuantity(state, value){
      state.pageQuantity = value
    },
    setStatus(state, value) {
      state.status = value
    },
    setOffset(state, value) {
      state.offset = value
    },
    setDate(state, value) {
      state.date = value
    },
    setActualPage(state, value) {
      state.actualPage = value
    },
    setSelectedStatus(state, value) {
      state.selectedStatus = value
    },
    setSelectedCompany(state, value) {
      state.selectedCompany = value
    },
    setSelectedUser(state, value) {
      state.selectedUser = value
    },
    setOptions(state, value) {
      /* if(state.statusOptions.length === 1){
        value.status.forEach(item => {
          state.statusOptions.push(item)
        })
      } */
    }
  },
  actions: {},
};
